// To generate a new file similar to this one, run `pay js:run gql-v2 --type=query --name=<name> --dir=path/to/dir`.
// You can freely edit this file. To update the generated types, run `eslint` in `--fix` mode.
// Do not delete this comment. https://go/gql-operation-definition

import type {
  V2QueryOptionsWithoutVariables,
  SharedToken,
  V2QueryOptions,
  V2QueryReturn,
} from '@stripe-internal/data-v2/types';
import {graphql} from '@sail/data';
import {useV2Query} from '@stripe-internal/data-v2';

import type {
  Exact,
  StripeContextInput,
  Scalars,
  V2FundingSessionsInternalOpenEnumCryptoWalletTokenCurrency,
  V2FundingSessionsInternalOpenEnumCryptoWalletNetwork,
} from '@stripe-internal/data-v2/schema/types';
import type {GraphQlDocument} from '@sail/data';

const doc = graphql`
  query RetrieveFundingSessionQuery(
    $v2Context: StripeContextInput!
    $fndsess: String!
  ) {
    v2RetrieveFundingSession(context: $v2Context, fndsess: $fndsess) {
      id
      businessName: business_name
      logoUrl: logo_url
      merchantBranding: merchant_branding {
        backgroundColor: background_color
        buttonColor: button_color
      }
      fundingOptions: funding_options {
        cryptoWallet: crypto_wallet {
          id
          token
          network
          assetDisplayName: asset_display_name
        }
      }
    }
  }
`;

export const retrieveFundingSessionQuery: RetrieveFundingSessionQueryDocument =
  doc;

const retrieveFundingSessionQueryOptions: V2QueryOptionsWithoutVariables<RetrieveFundingSessionQueryDocument> =
  {
    fetchPolicy: 'network-only',
    expectedErrors: ['not_found'],
  } as const;

export default function useRetrieveFundingSessionQuery(
  options: V2QueryOptions<RetrieveFundingSessionQueryDocument>,
): V2QueryReturn<RetrieveFundingSessionQueryDocument> {
  return useV2Query(retrieveFundingSessionQuery, {
    ...retrieveFundingSessionQueryOptions,
    ...options,
  });
}

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type RetrieveFundingSessionQueryVariables = Exact<{
  v2Context: StripeContextInput;
  fndsess: Scalars['String'];
}>;

export type RetrieveFundingSessionQueryData = {
  readonly __typename: 'Query';
  readonly v2RetrieveFundingSession: {
    readonly __typename: 'V2FundingSessionsInternalFundingSessionInternalView';
    readonly id: string;
    readonly businessName: string;
    readonly logoUrl: string | null;
    readonly merchantBranding: {
      readonly __typename: 'V2FundingSessionsInternalMerchantBranding';
      readonly backgroundColor: string | null;
      readonly buttonColor: string | null;
    };
    readonly fundingOptions: {
      readonly __typename: 'V2FundingSessionsInternalFundingOptions';
      readonly cryptoWallet: ReadonlyArray<{
        readonly __typename: 'V2FundingSessionsInternalCryptoWalletFundingOption';
        readonly id: string;
        readonly token: V2FundingSessionsInternalOpenEnumCryptoWalletTokenCurrency;
        readonly network: V2FundingSessionsInternalOpenEnumCryptoWalletNetwork;
        readonly assetDisplayName: string;
      }>;
    };
  } | null;
};

export type RetrieveFundingSessionQueryToken = SharedToken<{
  Query_v2RetrieveFundingSession: true;
}>;

export type RetrieveFundingSessionQueryDocument = GraphQlDocument<
  RetrieveFundingSessionQueryData,
  RetrieveFundingSessionQueryVariables,
  RetrieveFundingSessionQueryToken
>;
